<template>
  <div id="app">
    <el-form
      style="margin-top: 15px"
      size="small"
      :inline="true"
      :model="search"
    >
      <el-form-item>
        <el-date-picker
          style="width: 250px; margin-left: 25px"
          v-model="search.start_end"
          value-format="yyyy-MM-dd"
          type="daterange"
          start-placeholder="start time"
          end-placeholder="end time"
        ></el-date-picker>
      </el-form-item>
      <el-form-item>
        <el-button type="primary" @click="to_search()">search</el-button>
      </el-form-item>
    </el-form>

    <div id="map" style="width: 100%; height: 450px"></div>
    <div style="margin-top:10px;"><b>totalCount: {{totalCount}}</b></div>
    <el-table
      v-tb-height="{ bottom: 40, self: this }"
      :height="height"
      stripe
      border
      :data="listdata"
      empty-text="Temporarily no data"
    >
      <el-table-column label="No" type="index"></el-table-column>
      <el-table-column prop="city" label="City"></el-table-column>
      <el-table-column prop="totalCount" label="count"></el-table-column>
    </el-table>
  </div>
</template>
<script>
import router from "../../../router";
import "echarts/map/world";
export default {
  name: "MapDecvices",
  components: {},
  data() {
    return {
      height:0,
      geoCoordMap: {},
      search: {
        start: this.getNextDate(-7),
        end: this.getNextDate(0),
        start_end: [this.getNextDate(-7), this.getNextDate(0)],
      },
      listdata: [],
      mapData: [],
      totalCount: 0
    };
  },
  methods: {
    getNextDate: function (day) {
      var dd = new Date();
      dd.setDate(dd.getDate() + day);
      var y = dd.getFullYear();
      var m =
        dd.getMonth() + 1 < 10 ? "0" + (dd.getMonth() + 1) : dd.getMonth() + 1;
      var d = dd.getDate() < 10 ? "0" + dd.getDate() : dd.getDate();
      return y + "-" + m + "-" + d;
    },
    to_search() {
      if (this.search.start_end) {
        this.search.start = this.search.start_end["0"];
        this.search.end = this.search.start_end["1"];
      } else {
        this.search.start = this.getNextDate(-7);
        this.search.end = this.getNextDate(0);
      }
      this.getData(false);
    },
    async getData() {
      this.listdata=[];
      this.mapData = [];
      let loading = this.$util.loading()
      this.$api.rootV1.post("/web/city/list", {}, (res) => {
        let geoCoordMap = {};
        for (let item of res.data) {
          geoCoordMap[item.city] = [
            item.google_longitude,
            item.google_latitude,
          ];
        }
        this.geoCoordMap = geoCoordMap;
        this.$api.rootV1.post(
          "/web/statistics/devicecity",
          this.search,
          (res) => {
            var mapData = [];
            var listdata=[];
            let totalcount=0;
            let geoCoordMaps = this.geoCoordMap;
            for (let item of res.data) {
              if (item.city != "") {
                listdata.push(item)
                let size = 0,count = parseInt(item.totalCount);
                totalcount+=count;
                if (count <= 50) {
                  size = 3 + Math.round(count / 10);
                } else if (count <= 150) {
                  size = 8 + Math.round((count - 50) / 13);
                } else if (count <= 500) {
                  size = 15 + Math.round((count - 150) / 70);
                } else if (count <= 1000) {
                  size = 20 + Math.round((count - 500) / 50);
                } else {
                  size = 30 + Math.round((count - 1000) / 1000);
                }
                if(geoCoordMaps[item.city]){
                  mapData.push({
                    name: item.city,
                    value: [geoCoordMaps[item.city][0],geoCoordMaps[item.city][1],size,item.totalCount]//geoCoordMaps[item.city].concat(size).concat(item.totalCount),
                  });
                }

              }
            }
            this.totalCount=totalcount
            this.listdata=listdata;
            this.mapData = mapData;
            this.drawChart(mapData);
            loading.close()
          }
        );
      });
      
      
    },
    drawChart(mapData) {
      let search=this.search
      var echarts = require("echarts");
      // 基于准备好的dom，初始化echarts实例
      let myChart = echarts.init(document.getElementById("map"));
      // 指定图表的配置项和数据
      let option = {
        backgroundColor: new echarts.graphic.RadialGradient(0.5, 0.5, 0.4, [
          {
            offset: 0,
            color: "#4b5769",
          },
          {
            offset: 1,
            color: "#404a59",
          },
        ]),
        title: {
          text: "Devices region distribution",
          subtext: "data from storypod",
          left: "center",
          top: 5,
          itemGap: 0,
          textStyle: {
            color: "#eee",
          },
          z: 200,
        },
        tooltip: {
          trigger: "item",
          triggerOn: "click",
          formatter: function (params) {
            router.push({ path: "/devices", query: { city: params.name,start:search.start,end:search.end } });
            var value = (params.value + "").split(".");
            value =
              value[0].replace(/(\d{1,3})(?=(?:\d{3})+(?!\d))/g, "$1,") +
              "." +
              value[1];
            return (
              params.seriesName +
              "<br/>" +
              params.name +
              " : " +
              value +
              "<br/>totalCount: " +
              params.value[3]
            );
          },
        },

        geo: {
          map: "world",
          silent: true,
          label: {
            emphasis: {
              show: false,
              areaColor: "#eee",
            },
          },
          itemStyle: {
            normal: {
              borderWidth: 0.2,
              borderColor: "#404a59",
            },
          },
          left: "6%",
          top: 40,
          bottom: "6%",
          right: "14%",
          roam: true,
        },
        series: [
          {
            name: "Device statistic",
            type: "effectScatter",
            coordinateSystem: "geo",
            symbolSize: function (val) {
              console.log("size=", val[2]);
              return val[2];
            },
            data: mapData,
            activeOpacity: 1,
            label: {
              normal: {
                formatter: function (params) {
                  return (
                    params.data.name + "\ntotalCount: " + params.data.value[3]
                  );
                },
                position: "right",
                show: false,
              },
              emphasis: { show: true },
            },
            itemStyle: {
              normal: { borderColor: "#fff", color: "#577ceb" },
            },
          },
        ],
      };
      // 使用刚指定的配置项和数据显示图表。
      myChart.setOption(option, true);
    },
  },
  mounted() {
    this.getData();
  },
};
</script>


// WEBPACK FOOTER //
// src/components/main/statistics/MapDecvices.vue